import React from 'react';
import styles from '../../Accounting.module.css';
import { CheckIcon } from '../../icons';

const left = [
  'Income auto-recorded & reconciled',
  'Upload expenses & receipts',
  'Connect your bank account',
  'Income & expenses by category',
  'Net profit at a glance',
];

const right = [
  'AI expense categorization',
  'AI-flagged deductions',
  'Exportable reports (CSV / PDF)',
  'Year-end summaries',
  'Share with your accountant',
];

const Capabilities = () => (
  <section className={styles.sec} style={{ paddingTop: 0 }}>
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />All the details</span>
        <h2>Everything in Fyntiq accounting.</h2>
      </div>
      <div className={`${styles.capabilitiesGrid} ${styles.sr}`} data-sr>
        <ul className={styles.fList}>
          {left.map((t) => <li key={t}><CheckIcon />{t}</li>)}
        </ul>
        <ul className={styles.fList}>
          {right.map((t) => <li key={t}><CheckIcon />{t}</li>)}
        </ul>
      </div>
    </div>
  </section>
);

export default Capabilities;
